export const styleGoalGridContainer = {
    minHeight: "55px",
    backgroundColor: "#373737",
    borderTop: "4px solid #297373",
    borderBottom: "4px solid #297373",
    boxShadow: "0 4px 6px rgba(0,0,0,.2)",
    marginTop: "20px"
}

export const styleSpan = {
    color: "#ff8552",
    fontWeight: "bold"
}